<template>
<form @submit.prevent="onsubmit">
  <va-input
    v-model="logar.email"
    type="email"
    :label="$t('auth.email')"
    :error="!!emailErrors.length"
    :error-messages="emailErrors"
  />

  <va-input
    v-model="logar.password"
    type="password"
    :label="$t('auth.password')"
    :error="!!passwordErrors.length"
    :error-messages="passwordErrors"
  />

  <div class="auth-layout__options d-flex align--center justify--space-between">
    <!-- <va-checkbox v-model="keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')"/> -->
    <!-- <router-link class="ml-1 link" :to="{name: 'login-professor'}">{{$t('gestaopessoas.Professores')}}</router-link>  -->
    <!-- <router-link class="ml-1 link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link> -->
  </div>

  <div class="flex  mt-3">
        <!-- :disabled="logar.password === ''" -->
      <va-button type="submit" color="info"  class="my-0 tamanho">{{ $t('auth.login') }}</va-button>
    <va-button type="submit" color="info" @click="recuperar_senha()" class="my-0 tamanho" flat>{{$t('auth.recover_password')}}</va-button>        
  </div>
</form>
</template>

<script>
import url from '../../../store/modules/urls'
import axios from 'axios';
export default {
  name: 'login',
  data () {
    return {
      logar:{
        email: '',
        password: '',
      },
      
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
    }
  },
  computed: {
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    onsubmit () {
      this.emailErrors = this.logar.email ? [] : ['Email is required']
      this.passwordErrors = this.logar.password ? [] : ['Password is required']
      if (!this.formReady) {
        return
      }

        const USER_TOKEN = localStorage.getItem('access_token');
    
        axios.post(url.api_admin + 'auth/login-professor?token='+USER_TOKEN,
      
        {

         email: this.logar.email,
         password: this.logar.password

         }).then(response =>{

          console.log(response.data.data)
           localStorage.access_token = response.data.data;
           if (response.data.data.perfil_id == 1) {
             this.$store.dispatch('setProfessor',response.data.data);
             this.$router.push({ name: 'administrador/home' })
           }if (response.data.data.perfil_id == 2) {
             this.$store.dispatch('setProfessor',response.data.data);
             this.$router.push({ name: 'areaprofessor/materias' })
           }
             
         }).catch(error=>{
            console.log(error);
          // localStorage.removeItem('access_token');
          
          });

      
    },
    recuperar_senha(){
      //  this.$router.push({ name: 'inscricao/formulario' })
       this.$router.push({ name: 'recover-password' })
     
    }
  },
}
</script>

<style lang="scss">
</style>
